var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab",style:({
    backgroundColor: _vm.tabAttr.backgroundColor,
    border: _vm.tabAttr.border,
  })},[_c('BCheckbox',{attrs:{"type":_vm.tabAttr.type,"disabled":true},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("\n    "+_vm._s(_vm._f("t")(_vm.tabAttr.title))+"\n  ")]),_c('p',{staticClass:"total"},[_vm._v("\n    "+_vm._s(_vm.computedTabTotal)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }